import DataGrid, {Column, Editing, Pager, Paging, SearchPanel, Export, Sorting} from "devextreme-react/data-grid";
import axios from 'axios'
import {useSnackbar} from "notistack";
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {jsPDF} from 'jspdf';
import ExcelJS from "exceljs";
import {exportDataGrid as exportDataGridToPdf} from 'devextreme/pdf_exporter';
import format from "date-fns/format";
import {createRef, useState} from "react";
import {exportDataGrid} from "devextreme/excel_exporter";
import autoTable from 'jspdf-autotable'
import saveAs from 'file-saver';
import Dialog from "../../../../palette/Dialog";
import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import {FormContainer} from "../../../../palette/Palette";
import {FilterTwo} from "../../../../utils/HelpFunctions";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
}

const urlDelete = 'https://users-easi4xatjq-uc.a.run.app/delete'
const urlResendPwd = 'https://resend-password-easi4xatjq-uc.a.run.app/resend-password'

function UsersGrid(props) {

    const {
        dataSource, trigger, setTrigger, DataStore, loading, setVisibleForm, setEdit, setVisibleGrid, setDataEdit
    } = props

    const {imageAsUrl, contactNumbers, idCompany, companyName} = DataStore

    const [openDialog, setOpenDialog] = useState(false)
    const [dataSend, setDataSend] = useState(null)
    const [load, setLoad] = useState(false)
    const [textButton, setTextButton] = useState('Enviar')

    const {enqueueSnackbar} = useSnackbar();
    const dataGridRef = createRef();

    const onRowRemoved = async (e) => {

        if (e.data.role === 'sroot') {

            const filterAdmin = FilterTwo(dataSource, 'role', 'status', 'sroot', 'Cuenta activa')
            if (filterAdmin.length > 1) {
                const data = {userEmail: e.data.userEmail}

                if (e.data.status !== 'Cuenta eliminada') {
                    await axios.post(urlDelete, data, {headers: headers})
                        .then(async (res) => {
                            if (res.data.status === 'OK') {
                                await db.collection('Users').doc(res.data.uid).update({
                                    status: false
                                }).then(() => {
                                    NotiStackInfo('Usuario eliminado exitosamente!', 'success', enqueueSnackbar)
                                    setTrigger(!trigger)
                                })
                            } else {
                                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                                setTrigger(!trigger)
                            }
                        }).catch(() => {
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                            setTrigger(!trigger)
                        })
                } else {
                    NotiStackInfo('Esta cuenta ya a sido eliminada', 'warning', enqueueSnackbar)
                    setTrigger(!trigger)
                }
            } else {
                NotiStackInfo('No se puede eliminar el usuario administrador!', 'error', enqueueSnackbar)
                setTrigger(!trigger)
            }
        }else{
            const data = {userEmail: e.data.userEmail}

            if (e.data.status !== 'Cuenta eliminada') {
                await axios.post(urlDelete, data, {headers: headers})
                    .then(async (res) => {
                        if (res.data.status === 'OK') {
                            await db.collection('Users').doc(res.data.uid).update({
                                status: false
                            }).then(() => {
                                NotiStackInfo('Usuario eliminado exitosamente!', 'success', enqueueSnackbar)
                                setTrigger(!trigger)
                            })
                        } else {
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                            setTrigger(!trigger)
                        }
                    }).catch(() => {
                        NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        setTrigger(!trigger)
                    })
            } else {
                NotiStackInfo('Esta cuenta ya a sido eliminada', 'warning', enqueueSnackbar)
                setTrigger(!trigger)
            }
        }
    }

    const resendPwd = (e) => {
        if (e.row.data.status === 'Cuenta activa') {
            setDataSend({
                email: e.row.data.userEmail,
                name: e.row.data.username,
                uid: e.row.data.id,
                imageAsUrl,
                contactNumbers,
                idCompany,
                companyName
            })
            setOpenDialog(true)
        } else {
            NotiStackInfo('No se puede enviar una nueva contraseña a una cuenta que ya ha sido eliminada', 'error', enqueueSnackbar)
        }
    }

    const resendPassword = async () => {
        setLoad(true)
        setTextButton('Enviando...')

        await axios.post(urlResendPwd, dataSend, {headers: headers})
            .then((res) => {
                if (res.data === 'OK') {
                    setLoad(false)
                    setTextButton('Enviar')
                    setOpenDialog(false)
                    NotiStackInfo('La nueva clave a sido enviada exitosamente.', 'info', enqueueSnackbar)
                } else {
                    setLoad(false)
                    setTextButton('Enviar')
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                }
            })
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF();
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 35, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Usuarios`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 10, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 17, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 22, {baseline: 'top'});

                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Usuarios.pdf');
        });
    }

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'}
                        };
                    }
                }
            }
        }).then(function () {

            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Usuarios`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'}

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'}

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Usuarios.xlsx');
            });
        });
        e.cancel = true;
    }

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 155,
                text: 'Crear usuario',
                elementAttr: {id: 'button-add-grid'},
                icon: 'fas fa-plus-circle',
                onClick: () => {
                    setVisibleForm(true)
                    setEdit(false)
                    setVisibleGrid(false)
                }
            }
        })

    }

    const onRowUpdating = (e) => {
        if (e.row.data.status === 'Cuenta eliminada') {
            NotiStackInfo('No se puede editar una cuenta eliminada', 'warning', enqueueSnackbar)
        } else {
            setDataEdit(e.row.data)
            setEdit(true)
            setVisibleGrid(false)
            setVisibleForm(false)
        }
    }

    const buttons = [
        {
            hint: 'Editar',
            icon: 'fas fa-pencil-alt',
            visible: true,
            onClick: onRowUpdating,
        },
        {
            hint: 'Renviar contraseña',
            icon: 'fas fa-key',
            visible: true,
            onClick: resendPwd,
        },
        'delete'];

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="grid-container">
                <HeaderPage icon={'fas fa-user-tie'} text={'Gestión de usuarios'} load={loading}
                            textLoad={'Cargando...'}/>

                <Dialog setOpenDialog={setOpenDialog} openDialog={openDialog} title={'Reenviar contraseña'}
                        onClick={resendPassword} width={100} load={load} textButton={textButton}
                        text={`Esta seguro que desea reenviar la contraseña  a ${dataSend?.email} ?`}/>
                <FormContainer>
                    <DataGrid
                        ref={dataGridRef}
                        id="normal-grid"
                        dataSource={dataSource}
                        rowAlternationEnabled={true}
                        noDataText={'Esperando datos'}
                        onRowRemoving={onRowRemoved}
                        onToolbarPreparing={onToolbarPreparing}
                        showBorders={true}
                        onExporting={onExporting}
                    >
                        <SearchPanel visible={true}
                                     width={240}
                                     placeholder="Buscar"/>
                        <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                        <Sorting mode="multiple"/>
                        <Paging defaultPageSize={15}/>
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[5, 10, 20]}
                            showInfo={true}/>
                        <Editing
                            mode="row"
                            texts={{
                                editRow: 'Editar',
                                deleteRow: 'Eliminar cuenta',
                            }}
                            useIcons={true}
                            allowUpdating={true}
                            allowDeleting={true}
                        />

                        <Column dataField="dateCreation" alignment={'center'} caption={'Fecha de creacion'}/>

                        <Column dataField="username" alignment={'center'} caption={'Nombre'}/>

                        <Column dataField="companyMail" alignment={'center'} caption={'Correo de la empresa'}/>

                        <Column dataField="userEmail" alignment={'center'} caption={'Correo de usuario'}/>

                        <Column dataField="status" caption="Estado de la cuenta" cellRender={DiffCell}
                                alignment={'center'}/>

                        <Column type="buttons" width={110} buttons={buttons}/>

                    </DataGrid>
                </FormContainer>
            </div>
        </>
    )
}


export default UsersGrid

function DiffCell(cellData) {
    const status = cellData.data.status
    return (
        <div>
            <span
                style={{color: status === 'Cuenta activa' ? 'green' : 'red'}}>{status}</span>
        </div>
    );
}
